import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';
import BeforeAfterSection from './components/BeforeAfterSection';
import GoogleReviewPhotosSection from './components/GoogleReviewPhotosSection';
import OptimizedImage from '../../components/base/OptimizedImage';

const CasesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: '全部案例', icon: 'ri-grid-line' },
    { id: 'apartment', name: '套房搬遷', icon: 'ri-home-4-line' },
    { id: 'office', name: '辦公室搬遷', icon: 'ri-building-line' },
    { id: 'disposal', name: '廢棄物清運', icon: 'ri-delete-bin-line' },
    { id: 'labor', name: '人力搬工', icon: 'ri-team-line' }
  ];

  const cases = [
    {
      id: 1,
      category: 'apartment',
      title: '新北市泰山區家庭搬遷',
      location: '新北市泰山區',
      description: '對於家具的防護包裝做得相當精緻且到位，確保物品在運輸過程中不受損',
      image: 'https://public.readdy.ai/ai/img_res/24b1c00cb9e54098efec3d462c63bc58.jpg',
      items: ['沙發專業包裝', '床墊防護套', '家具防撞保護'],
      rating: 5,
      review: '對於家具的防護包裝做得相當精緻且到位，確保物品在運輸過程中不受損。動作迅速且俐落，分工明確，搬運效率很高。師傅們態度親切有耐心，讓整個搬家過程非常順利！',
      customerName: '陳先生',
      date: '2024年3月',
      serviceType: '家庭搬遷',
      duration: '4小時',
      workers: 3
    },
    {
      id: 2,
      category: 'apartment',
      title: '台北市大安區精緻搬家',
      location: '台北市大安區',
      description: '報價非常實在且透明，不會隨意加價，線上估價系統很方便',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20transparent%20pricing%20moving%20service%2C%20professional%20movers%20with%20clear%20pricing%20list%20and%20customer%20consultation%20in%20Taipei%20Daan%20district%2C%20organized%20moving%20process%20with%20labeled%20boxes%2C%20honest%20and%20reliable%20moving%20company%2C%20modern%20apartment%20relocation&width=800&height=600&seq=case2-daan-real&orientation=landscape',
      items: ['全套家具', '家電設備', '生活用品'],
      rating: 5,
      review: '報價非常實在且透明，不會隨意加價。線上估價系統很方便，預算清楚透明。師傅們準時到達，動作俐落，搬運過程非常專業。價格合理，服務品質優良，非常推薦！',
      customerName: '林小姐',
      date: '2024年3月',
      serviceType: '精緻搬家',
      duration: '5小時',
      workers: 3
    },
    {
      id: 3,
      category: 'apartment',
      title: '桃園市中壢區套房搬遷',
      location: '桃園市中壢區',
      description: '家具保護超仔細！沙發和床墊的防護包裝做得特別好',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20careful%20furniture%20protection%20moving%20service%2C%20movers%20wrapping%20sofa%20and%20mattress%20with%20professional%20protective%20materials%20in%20Taoyuan%20Zhongli%20district%2C%20detailed%20furniture%20packaging%20process%2C%20protective%20blankets%20and%20bubble%20wrap%2C%20meticulous%20moving%20service&width=800&height=600&seq=case3-zhongli-real&orientation=landscape',
      items: ['沙發防護包裝', '床墊保護套', '小型家具'],
      rating: 5,
      review: '家具保護超仔細！沙發和床墊的防護包裝做得特別好，完全不用擔心刮傷或損壞。師傅們很專業，知道怎麼處理各種家具。搬運過程很順利，價格也很合理，非常滿意！',
      customerName: '王太太',
      date: '2024年3月',
      serviceType: '套房搬遷',
      duration: '3小時',
      workers: 2
    },
    {
      id: 4,
      category: 'apartment',
      title: '新北市板橋區家庭搬家',
      location: '新北市板橋區',
      description: '回頭客推薦！第二次找建鈞搬家，24小時服務很方便',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%2024%20hour%20moving%20service%2C%20professional%20movers%20working%20efficiently%20in%20New%20Taipei%20Banqiao%20district%2C%20reliable%20repeat%20customer%20service%2C%20complete%20household%20moving%20with%20professional%20team%2C%20flexible%20scheduling%20moving%20service&width=800&height=600&seq=case4-banqiao-real&orientation=landscape',
      items: ['臥室家具', '客廳家具', '廚房用品'],
      rating: 5,
      review: '這是第二次找建鈞搬家了！上次的服務讓我印象深刻，所以這次搬家還是選擇他們。24小時服務真的很方便，可以配合我的時間。師傅們一樣專業細心，價格透明合理，值得信賴的搬家公司！',
      customerName: '張先生',
      date: '2024年2月',
      serviceType: '家庭搬家',
      duration: '5小時',
      workers: 3
    },
    {
      id: 5,
      category: 'apartment',
      title: '新竹市東區長途搬家',
      location: '新竹市東區',
      description: 'LINE諮詢超方便！全省回頭車服務讓長途搬家很划算',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20long%20distance%20moving%20service%20with%20return%20truck%2C%20professional%20moving%20truck%20loaded%20with%20furniture%20traveling%20between%20cities%2C%20economical%20long%20distance%20relocation%20service%20in%20Hsinchu%2C%20organized%20cargo%20loading%2C%20efficient%20provincial%20moving%20service&width=800&height=600&seq=case5-hsinchu-real&orientation=landscape',
      items: ['全套家具', '家電設備', '個人物品'],
      rating: 5,
      review: 'LINE諮詢超方便！客服回覆很快，解答所有疑問。全省回頭車服務讓長途搬家變得很划算，價格比預期便宜很多。師傅們很專業，長途運送也沒有任何損壞，非常推薦！',
      customerName: '李小姐',
      date: '2024年2月',
      serviceType: '長途搬家',
      duration: '6小時',
      workers: 3
    },
    {
      id: 6,
      category: 'disposal',
      title: '新北市新莊區廢棄物處理',
      location: '新北市新莊區',
      description: '清運服務超讚！師傅很細心，價格合理',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20professional%20waste%20disposal%20service%2C%20workers%20carefully%20removing%20old%20furniture%20and%20junk%20in%20New%20Taipei%20Xinzhuang%20district%2C%20organized%20waste%20collection%20truck%2C%20affordable%20and%20reliable%20junk%20removal%20service%2C%20clean%20disposal%20process&width=800&height=600&seq=case6-xinzhuang-real&orientation=landscape',
      items: ['舊家具清運', '雜物處理', '環保回收'],
      rating: 5,
      review: '清運服務超讚！師傅很細心，會幫忙分類可回收的物品。價格合理透明，沒有額外收費。動作很快，半天就清理乾淨了。服務態度很好，非常推薦他們的清運服務！',
      customerName: '黃先生',
      date: '2024年2月',
      serviceType: '廢棄物處理',
      duration: '3小時',
      workers: 2
    },
    {
      id: 7,
      category: 'apartment',
      title: '台北市信義區搬家服務',
      location: '台北市信義區',
      description: '師傅們動作迅速又細心，所有物品都完好無損',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20efficient%20and%20careful%20moving%20service%2C%20professional%20movers%20handling%20items%20with%20care%20in%20Taipei%20Xinyi%20district%2C%20fast%20and%20meticulous%20moving%20process%2C%20undamaged%20furniture%20delivery%2C%20high%20quality%20moving%20service&width=800&height=600&seq=case7-xinyi-real&orientation=landscape',
      items: ['精緻家具', '易碎物品', '家電設備'],
      rating: 5,
      review: '師傅們動作迅速又細心，所有物品都完好無損地送達新家。特別是易碎物品的包裝非常仔細，讓我很放心。服務態度親切，價格也很合理，是值得推薦的搬家公司！',
      customerName: '吳小姐',
      date: '2024年1月',
      serviceType: '精緻搬家',
      duration: '4小時',
      workers: 3
    },
    {
      id: 8,
      category: 'office',
      title: '新北市中和區辦公室搬遷',
      location: '新北市中和區',
      description: '辦公室搬遷效率高，完全不影響公司運作',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20efficient%20office%20relocation%20service%2C%20professional%20team%20moving%20office%20furniture%20and%20equipment%20in%20New%20Taipei%20Zhonghe%20district%2C%20organized%20business%20moving%20process%2C%20minimal%20disruption%20office%20move%2C%20professional%20commercial%20moving&width=800&height=600&seq=case8-zhonghe-real&orientation=landscape',
      items: ['辦公桌椅', '電腦設備', '文件櫃'],
      rating: 5,
      review: '辦公室搬遷效率高，完全不影響公司運作。師傅們提前規劃好搬運路線，所有設備都妥善保護。電腦和文件都分類整理得很好，搬到新辦公室後很快就能恢復營運，非常專業！',
      customerName: '劉經理',
      date: '2024年1月',
      serviceType: '辦公室搬遷',
      duration: '7小時',
      workers: 4
    },
    {
      id: 9,
      category: 'apartment',
      title: '桃園市桃園區家庭搬遷',
      location: '桃園市桃園區',
      description: '第一次搬家很緊張，但建鈞搬家讓整個過程變得很輕鬆',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20stress-free%20first%20time%20moving%20service%2C%20friendly%20movers%20helping%20nervous%20customer%20in%20Taoyuan%20district%2C%20relaxed%20and%20easy%20moving%20experience%2C%20professional%20guidance%20for%20first%20time%20movers%2C%20comfortable%20moving%20service&width=800&height=600&seq=case9-taoyuan-real&orientation=landscape',
      items: ['全套家具', '家電廚具', '衣物雜物'],
      rating: 5,
      review: '第一次搬家很緊張，但建鈞搬家讓整個過程變得很輕鬆。師傅們很有經驗，知道怎麼搬運大型家具。冰箱、洗衣機都處理得很好，價格也很合理。服務態度親切，非常推薦！',
      customerName: '鄭小姐',
      date: '2024年1月',
      serviceType: '家庭搬遷',
      duration: '5小時',
      workers: 3
    },
    {
      id: 10,
      category: 'apartment',
      title: '新北市三重區套房搬遷',
      location: '新北市三重區',
      description: '價格透明合理，服務品質優良，非常推薦',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20affordable%20quality%20moving%20service%2C%20professional%20movers%20with%20transparent%20pricing%20in%20New%20Taipei%20Sanchong%20district%2C%20excellent%20service%20quality%2C%20honest%20pricing%20moving%20company%2C%20reliable%20apartment%20relocation&width=800&height=600&seq=case10-sanchong-real&orientation=landscape',
      items: ['套房家具', '個人物品', '小型家電'],
      rating: 5,
      review: '價格透明合理，服務品質優良，非常推薦！報價清楚明確，沒有任何隱藏費用。師傅們準時到達，動作俐落專業。搬運過程很順利，所有物品都完好無損，非常滿意這次的搬家服務！',
      customerName: '周先生',
      date: '2024年1月',
      serviceType: '套房搬遷',
      duration: '3小時',
      workers: 2
    },
    {
      id: 11,
      category: 'labor',
      title: '台北市內湖區鋼琴搬運',
      location: '台北市內湖區',
      description: '鋼琴搬運真的需要專業！有專門的設備和技術',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20professional%20piano%20moving%20service%20with%20specialized%20equipment%2C%20skilled%20movers%20handling%20piano%20with%20safety%20straps%20and%20protective%20materials%20in%20Taipei%20Neihu%20district%2C%20expert%20piano%20transport%20techniques%2C%20careful%20heavy%20item%20moving&width=800&height=600&seq=case11-neihu-real&orientation=landscape',
      items: ['直立式鋼琴', '專業設備', '防護措施'],
      rating: 5,
      review: '鋼琴搬運真的需要專業！建鈞搬家有專門的設備和技術，師傅們非常小心謹慎。用專業的搬運帶和保護墊，確保鋼琴完好無損。雖然樓層高，但他們處理得很好，非常感謝！',
      customerName: '蔡小姐',
      date: '2023年12月',
      serviceType: '精緻物品搬運',
      duration: '3小時',
      workers: 3
    },
    {
      id: 12,
      category: 'disposal',
      title: '台北市松山區舊家具清運',
      location: '台北市松山區',
      description: '環保回收處理，讓我覺得很安心',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20eco-friendly%20furniture%20disposal%20service%2C%20workers%20responsibly%20removing%20old%20furniture%20with%20environmental%20awareness%20in%20Taipei%20Songshan%20district%2C%20green%20waste%20management%2C%20organized%20recycling%20process%2C%20sustainable%20junk%20removal&width=800&height=600&seq=case12-songshan-real&orientation=landscape',
      items: ['舊沙發床墊', '舊家電', '雜物清運'],
      rating: 5,
      review: '換新家具後不知道怎麼處理舊的，建鈞搬家的清運服務解決了我的煩惱。他們會做環保回收，讓我覺得很安心。師傅們態度很好，價格也很公道，下次還會再找他們！',
      customerName: '謝太太',
      date: '2023年12月',
      serviceType: '家具清運',
      duration: '3小時',
      workers: 2
    }
  ];

  const filteredCases = selectedCategory === 'all' 
    ? cases 
    : cases.filter(c => c.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="review" 
        data={{
          reviewRating: 4.9,
          reviewAuthor: '客戶見證',
          reviewDate: '2024-01-15',
          reviewText: '建鈞精緻搬家提供專業、安全、高效的搬家服務，累積5000+成功搬遷案例，客戶滿意度98%，是值得信賴的搬家公司'
        }}
      />

      <Header />

      {/* Hero Section - 優化視覺效果 */}
      <section className="relative py-24 bg-gradient-to-br from-teal-50 via-white to-emerald-50 overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line"></i>
            <span>5000+ 成功案例見證</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            真實客戶<span className="text-teal-600">搬家案例</span>分享
          </h1>
          
          <p className="text-xl text-gray-600 mb-4 max-w-3xl mx-auto leading-relaxed">
            每一個案例都是我們的承諾，每一份信任都是我們的責任
          </p>
          
          <p className="text-lg text-gray-500 mb-10 max-w-2xl mx-auto">
            從套房搬遷到辦公室搬遷，從廢棄物清運到精緻物品搬運，我們用專業和細心贏得客戶的信賴
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="tel:0978900081"
              className="bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center gap-2"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>立即來電：0978-900-081</span>
            </a>
            <a 
              href="https://line.me/ti/p/sadiest018moving"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#06C755] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#05b34c] transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center gap-2"
            >
              <i className="ri-line-fill text-xl"></i>
              <span>LINE 免費諮詢</span>
            </a>
          </div>

          {/* 信任指標 */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-md">
              <div className="text-3xl font-bold text-teal-600 mb-1">5000+</div>
              <div className="text-sm text-gray-600">成功案例</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-md">
              <div className="text-3xl font-bold text-teal-600 mb-1">98%</div>
              <div className="text-sm text-gray-600">滿意度</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-md">
              <div className="text-3xl font-bold text-teal-600 mb-1">10+</div>
              <div className="text-sm text-gray-600">年經驗</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-md">
              <div className="text-3xl font-bold text-teal-600 mb-1">24/7</div>
              <div className="text-sm text-gray-600">全天服務</div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter - 優化設計 */}
      <section className="py-6 bg-white sticky top-16 z-40 shadow-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2 text-gray-600">
              <i className="ri-filter-3-line text-xl"></i>
              <span className="font-medium">篩選案例類型</span>
            </div>
            <div className="text-sm text-gray-500">
              共 <span className="font-semibold text-teal-600">{filteredCases.length}</span> 個案例
            </div>
          </div>
          
          <div className="flex flex-wrap gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                  selectedCategory === category.id
                    ? 'bg-teal-600 text-white shadow-lg scale-105'
                    : 'bg-gray-100 text-gray-700 hover:bg-teal-50 hover:text-teal-600 hover:shadow-md'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.name}</span>
                {selectedCategory === category.id && (
                  <i className="ri-check-line text-lg"></i>
                )}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Cases Grid - 全面優化 */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCases.map((caseItem, index) => (
              <Link
                key={caseItem.id}
                to={
                  caseItem.id === 1 ? '/case-detail-1' : 
                  caseItem.id === 2 ? '/case-detail-2' : 
                  caseItem.id === 7 ? '/case-detail-3' : 
                  caseItem.id === 3 ? '/case-detail-4' : 
                  '/cases-detail'
                }
                className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group transform hover:-translate-y-2"
              >
                {/* 案例圖片 */}
                <div className="relative h-64 overflow-hidden">
                  <OptimizedImage
                    src={caseItem.image}
                    alt={caseItem.title}
                    className="w-full h-full"
                    priority={index < 3}
                  />
                  
                  {/* 地點標籤 */}
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg z-10">
                    <div className="flex items-center gap-2 text-teal-600">
                      <i className="ri-map-pin-line"></i>
                      <span className="text-sm font-semibold">{caseItem.location}</span>
                    </div>
                  </div>

                  {/* 服務類型標籤 */}
                  <div className="absolute top-4 right-4 bg-teal-600 text-white px-4 py-2 rounded-full shadow-lg z-10">
                    <span className="text-sm font-semibold">{caseItem.serviceType}</span>
                  </div>

                  {/* 評分顯示 */}
                  <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg z-10">
                    <div className="flex items-center gap-1">
                      {[...Array(caseItem.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>
                  </div>

                  {/* 查看詳情提示 */}
                  <div className="absolute inset-0 bg-teal-600/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-20">
                    <div className="text-center text-white">
                      <i className="ri-eye-line text-5xl mb-3"></i>
                      <div className="text-xl font-bold">查看完整案例</div>
                      <div className="text-sm mt-2">詳細搬家過程照片</div>
                    </div>
                  </div>
                </div>

                {/* 案例資訊 */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {caseItem.title}
                  </h3>

                  <p className="text-gray-600 mb-4 leading-relaxed">{caseItem.description}</p>
                  
                  {/* 服務詳情 */}
                  <div className="grid grid-cols-3 gap-3 mb-4">
                    <div className="bg-teal-50 rounded-xl p-3 text-center">
                      <i className="ri-time-line text-teal-600 text-xl mb-1"></i>
                      <div className="text-xs text-gray-600">工作時間</div>
                      <div className="text-sm font-semibold text-gray-900">{caseItem.duration}</div>
                    </div>
                    <div className="bg-emerald-50 rounded-xl p-3 text-center">
                      <i className="ri-team-line text-emerald-600 text-xl mb-1"></i>
                      <div className="text-xs text-gray-600">搬運人力</div>
                      <div className="text-sm font-semibold text-gray-900">{caseItem.workers} 人</div>
                    </div>
                    <div className="bg-teal-50 rounded-xl p-3 text-center">
                      <i className="ri-star-fill text-teal-600 text-xl mb-1"></i>
                      <div className="text-xs text-gray-600">客戶評分</div>
                      <div className="text-sm font-semibold text-gray-900">{caseItem.rating}.0</div>
                    </div>
                  </div>
                  
                  {/* 搬運物品 */}
                  <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-4 mb-4">
                    <div className="flex items-center gap-2 text-sm font-semibold text-teal-900 mb-3">
                      <i className="ri-box-3-line text-lg"></i>
                      <span>搬運物品清單</span>
                    </div>
                    <div className="space-y-2">
                      {caseItem.items.map((item, index) => (
                        <div key={index} className="flex items-center gap-2 text-sm text-gray-700">
                          <i className="ri-checkbox-circle-fill text-teal-600"></i>
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* 客戶評價 */}
                  <div className="border-t border-gray-200 pt-4">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-semibold shadow-md">
                          <i className="ri-user-3-fill text-xl"></i>
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900">{caseItem.customerName}</div>
                          <div className="text-xs text-gray-500 flex items-center gap-1">
                            <i className="ri-calendar-line"></i>
                            {caseItem.date}
                          </div>
                        </div>
                      </div>
                      <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-xs font-semibold">
                        已驗證
                      </div>
                    </div>
                    
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="flex items-start gap-2">
                        <i className="ri-double-quotes-l text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                        <p className="text-sm text-gray-700 leading-relaxed flex-1">
                          {caseItem.review}
                        </p>
                        <i className="ri-double-quotes-r text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 為什麼選擇我們 - 新增區塊 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">為什麼客戶選擇建鈞搬家？</h2>
            <p className="text-xl text-gray-600">專業、安全、高效，是我們的承諾</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-shield-check-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">全程保險保障</h3>
              <p className="text-gray-600 text-sm">每件物品都有保險，讓您搬家更安心</p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-team-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">專業搬運團隊</h3>
              <p className="text-gray-600 text-sm">10年以上經驗，專業訓練認證</p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-price-tag-3-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">透明收費標準</h3>
              <p className="text-gray-600 text-sm">明確報價，絕無隱藏費用</p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-customer-service-2-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">24小時客服</h3>
              <p className="text-gray-600 text-sm">隨時為您解答疑問，提供協助</p>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家前後對比照片 */}
      <BeforeAfterSection />

      {/* Stats Section - 優化設計 */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-emerald-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">用數據說話，見證我們的專業</h2>
            <p className="text-xl text-teal-100">每一個數字背後，都是客戶的信任與肯定</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 transform hover:scale-105 transition-all">
              <div className="text-6xl font-bold text-white mb-2">5000+</div>
              <div className="text-teal-100 font-medium text-lg">成功搬遷案例</div>
              <div className="text-teal-200 text-sm mt-2">持續增長中</div>
            </div>
            
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 transform hover:scale-105 transition-all">
              <div className="text-6xl font-bold text-white mb-2">10+</div>
              <div className="text-teal-100 font-medium text-lg">年專業經驗</div>
              <div className="text-teal-200 text-sm mt-2">深耕北台灣</div>
            </div>
            
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 transform hover:scale-105 transition-all">
              <div className="text-6xl font-bold text-white mb-2">98%</div>
              <div className="text-teal-100 font-medium text-lg">客戶滿意度</div>
              <div className="text-teal-200 text-sm mt-2">五星好評</div>
            </div>
            
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 transform hover:scale-105 transition-all">
              <div className="text-6xl font-bold text-white mb-2">0</div>
              <div className="text-teal-100 font-medium text-lg">客訴紀錄</div>
              <div className="text-teal-200 text-sm mt-2">零投訴承諾</div>
            </div>
          </div>
        </div>
      </section>

      {/* 客戶見證輪播 - 新增區塊 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">客戶真實評價</h2>
            <p className="text-xl text-gray-600">聽聽他們怎麼說</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">
                "建鈞搬家的服務真的很專業！從報價到搬運都很透明，師傅們動作迅速又細心，強烈推薦！"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-semibold">
                  王
                </div>
                <div>
                  <div className="font-semibold text-gray-900">王先生</div>
                  <div className="text-sm text-gray-500">台北市信義區</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">
                "第一次搬家很緊張，但建鈞搬家讓整個過程變得很輕鬆。價格合理，服務態度也很好！"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-semibold">
                  李
                </div>
                <div>
                  <div className="font-semibold text-gray-900">李小姐</div>
                  <div className="text-sm text-gray-500">新北市板橋區</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">
                "公司搬遷找建鈞搬家真的找對了！他們很了解辦公室搬遷的需求，效率超高！"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-semibold">
                  陳
                </div>
                <div>
                  <div className="font-semibold text-gray-900">陳經理</div>
                  <div className="text-sm text-gray-500">桃園市中壢區</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google 評論照片牆 - 真實客戶分享 */}
      <GoogleReviewPhotosSection />

      {/* CTA Section - 優化設計 */}
      <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-2xl p-12">
            <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-gift-line"></i>
              <span>立即預約享優惠</span>
            </div>
            
            <h2 className="text-4xl font-bold text-gray-900 mb-4">準備搬家了嗎？</h2>
            <p className="text-xl text-gray-600 mb-8">
              立即聯絡我們，免費估價，專業服務
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link 
                to="/quote"
                className="bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-calculator-line text-xl"></i>
                <span>線上免費估價</span>
              </Link>
              
              <a 
                href="tel:0978900081"
                className="bg-white border-2 border-teal-600 text-teal-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-50 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>0978-900-081</span>
              </a>
              
              <a 
                href="https://line.me/ti/p/sadiest018moving"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#06C755] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#05b34c] transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-line-fill text-xl"></i>
                <span>LINE 諮詢</span>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">免費到府估價</div>
                  <div className="text-sm text-gray-600">專人現場評估，精準報價</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">透明收費標準</div>
                  <div className="text-sm text-gray-600">明確報價，絕無隱藏費用</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">全程保險保障</div>
                  <div className="text-sm text-gray-600">讓您的物品搬遷更安心</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CasesPage;
